/* eslint-disable max-len, i18next/no-literal-string */
import React from 'react';

export function RightArrow(props): JSX.Element {
  return (
    <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M-4.9403e-07 8.4375L11.4094 8.4375L6.16875 13.6781L7.5 15L15 7.5L7.5 -1.14592e-06L6.17812 1.32187L11.4094 6.5625L-6.35182e-07 6.5625L-4.9403e-07 8.4375Z'
        fill='#272727'
      />
    </svg>
  );
}
